import { render, staticRenderFns } from "./Renegotiations.vue?vue&type=template&id=f4c95b12"
import script from "./Renegotiations.vue?vue&type=script&lang=js"
export * from "./Renegotiations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports